<template>
  <div class="feed-and-games-list">
    <div class="form">
      <div class="form__row">
        <label class="form__label">Feed</label>
        <Loader v-if="isFeedsLoadInProgress"></Loader>
        <select v-else class="form__select"
                v-model="selectedFeed"
                @change="onSelectFeedChange">
          <option :value="null" disabled selected hidden>(Select feed)</option>
          <option :value="feed.id" :key="feed.id" v-for="(feed) in feeds">{{feed.name}}</option>
        </select>
      </div>

      <div class="form__row">
        <FilterInput title="Filter games"
                    :filterList="games"
                    :filterByKey="gameFilterFields"
                    v-on:filter="onFilterGames"
        ></FilterInput>
      </div>

      <Loader v-if="isGamesLoadInProgress"></Loader>
      <ul v-else class="selectable-list feed-list-container">
        <li class="selectable-list__item"
            :class="{'active': isGameSelected(game)}"
            v-for="(game, i) in filteredGames"
            :key="game + i"
            @click="onSelectGameClick(game)">
          {{game.slug}} {{game.name}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import config from '../../../config'
  import Loader from '../../Loader/Loader.vue'
  import FilterInput from '../../FilterInput/FilterInput.vue'

  export default {
    name: 'FeedsAndGamesList',
    components: {Loader, FilterInput},
    props: [],
    data () {
      return {
        feeds: [],
        selectedFeed: null,
        isFeedsLoadInProgress: false,
        games: [],
        filteredGames: [],
        selectedGame: null,
        isGamesLoadInProgress: false,
        gameFilterFields: ['slug']
      }
    },
    created: function () {
      this.getFeeds()
    },
    methods: {
      onFilterGames: function (games) {
        this.filteredGames = games
      },
      isGameSelected (game) {
        return this.selectedGame && game === this.selectedGame
      },
      onSelectFeedChange: function () {
        this.isGamesLoadInProgress = true

        this.$gameApi.get(`/feeds/${this.selectedFeed}`)
          .then(response => {
            this.games = response.items
            this.filteredGames = this.games
            this.$emit('selected-feed-changed', this.selectedFeed, this.games)
            this.isGamesLoadInProgress = false
          }, error => {
            console.log(error)
            this.isGamesLoadInProgress = false
          })
      },
      onSelectGameClick: function (game) {
        this.selectedGame = game
        game.feedId = this.selectedFeed
        this.$emit('selected-game-changed', game)
      },
      getFeeds: function () {
        this.isFeedsLoadInProgress = true

        this.$gameApi.get(`/feeds`)
          .then(response => {
            this.feeds = response
            this.isFeedsLoadInProgress = false
          }, error => {
            console.log(error)
            this.isFeedsLoadInProgress = false
          })
      }
    }
  }
</script>

<style scoped lang="scss" src="./FeedsAndGamesList.scss" ></style>
